"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const material_2 = require("@mui/material");
const react_1 = require("react");
const zustandStore_1 = require("../../../zustandStore");
const walletHeader_1 = __importDefault(require("./walletHeader"));
const WalletContainer = ({ children }) => {
    const { setHeaderName } = (0, zustandStore_1.useZustand)();
    const theme = (0, material_2.useTheme)();
    (0, react_1.useEffect)(() => {
        setHeaderName('Wallet');
    }, [setHeaderName]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(walletHeader_1.default, {}), (0, jsx_runtime_1.jsx)(material_1.Container, { style: {
                    overflow: 'auto',
                    height: '100vh',
                    maxWidth: '100vw',
                    padding: `0 ${theme.tsGoUnit.tsUnitHalf}`,
                }, children: children })] }));
};
exports.default = WalletContainer;
